import {START_ANALYSE} from '../../constants/actions';

import {IAction} from '../../interfaces/action';

export const startAnalyse = (): IAction => ({
  type: START_ANALYSE
});
